import { useNavigate } from "react-router-dom";

import EmptyTable from "components/EmptyTable";
import { Table, Heading, FieldName, Row, FieldValueWithBorder } from "components/LayoutParts";
import NotificationCategorySwitcher from "pages/AtPort/component/NotificationCategorySwitcher";
import NotificationHomeDisplaySwitcher from "pages/AtPort/component/NotificationHomeDisplaySwitcher";
import PaginationForAtPort from "pages/AtPort/component/PaginationForAtPort";
import { dateFormat } from "utils/dateTimeUtils";

const SystemNotificationTable: { label: string; flex: number; sortKey?: string }[] = [
  {
    label: "カテゴリ",
    flex: 15,
  },
  {
    label: "タイトル",
    flex: 61,
  },
  {
    label: "ホーム画面に表示",
    flex: 15,
  },
  {
    label: "送信日",
    flex: 15,
  },
];

const DataTable = ({
  notificationList,
  totalPages,
  pagination,
  pageOption,
  setPageOption,
}: {
  notificationList: AtPortSystemNotification[];
  totalPages: number;
  pageOption: AtPortPageOption;
  pagination?: AtPortPageInfo;
  setPageOption: React.Dispatch<React.SetStateAction<AtPortPageOption>>;
}) => {
  const navigate = useNavigate();

  const onClickRow = (notificationId: string) => navigate(`/at_port/system_notification/${notificationId}/edit`);

  const onClickAddNotification = () => navigate("/at_port/system_notification/create");

  return (
    <>
      <Table>
        <Heading>
          {SystemNotificationTable.map((column, i) => (
            <FieldName key={column.label} flex={column.flex} lastColumn={i === SystemNotificationTable.length - 1}>
              {column.label}
            </FieldName>
          ))}
        </Heading>
        {notificationList.length > 0 ? (
          notificationList.map((notification) => (
            <Row key={notification.id} onClick={() => onClickRow(notification.id)}>
              <FieldValueWithBorder flex={SystemNotificationTable[0].flex}>
                <NotificationCategorySwitcher category={notification.category} />
              </FieldValueWithBorder>
              <FieldValueWithBorder flex={SystemNotificationTable[1].flex}>{notification.title}</FieldValueWithBorder>
              <FieldValueWithBorder flex={SystemNotificationTable[2].flex}>
                <NotificationHomeDisplaySwitcher homeDisplay={notification.homeDisplay} />
              </FieldValueWithBorder>
              <FieldValueWithBorder flex={SystemNotificationTable[3].flex}>
                {dateFormat(notification.createdAt, "YYYY/MM/DD")}
              </FieldValueWithBorder>
            </Row>
          ))
        ) : (
          <EmptyTable handleClick={onClickAddNotification} label="お知らせを追加" message="お知らせが見つかりません" />
        )}
      </Table>
      <PaginationForAtPort
        endCursor={pagination?.endCursor ?? ""}
        startCursor={pagination?.startCursor ?? ""}
        hasNextPage={pagination?.hasNextPage ?? false}
        hasPreviousPage={pagination?.hasPreviousPage ?? false}
        pageOption={pageOption}
        totalPageCount={totalPages}
        setPageOption={setPageOption}
      />
    </>
  );
};

export default DataTable;
